import React from 'react';

import { Table, TableContainer } from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { ISalesDetails } from '../../../../types/sales-details.type';
import SalesDetailsListBody from '../SalesDetailsListBody';
import SalesDetailsListFooter from '../SalesDetailsListFooter';
import SalesDetailsListHead from '../SalesDetailsListHead';
import SalesDetailsTotal from '../SalesDetailsTotal';

interface IProps {
  details: ISalesDetails[];
}

const SalesDetailsList = React.memo(({ details }: IProps) => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <SalesDetailsTotal details={details} />
    </Grid>

    <Grid item xs={12}>
      <TableContainer component={Paper} sx={{ maxHeight: '80vh' }}>
        <Table stickyHeader aria-label="sticky table">
          <SalesDetailsListHead />
          <SalesDetailsListBody details={details} />
          <SalesDetailsListFooter details={details} />
        </Table>
      </TableContainer>
    </Grid>
  </Grid>
));

export default SalesDetailsList;
